"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelTransactionHistoryItemTypeEnum = exports.FuelTransactionHistoryItemToJSON = exports.FuelTransactionHistoryItemFromJSONTyped = exports.FuelTransactionHistoryItemFromJSON = void 0;
var runtime_1 = require("../runtime");
function FuelTransactionHistoryItemFromJSON(json) {
    return FuelTransactionHistoryItemFromJSONTyped(json, false);
}
exports.FuelTransactionHistoryItemFromJSON = FuelTransactionHistoryItemFromJSON;
function FuelTransactionHistoryItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'fiatAmount': !(0, runtime_1.exists)(json, 'fiatAmount') ? undefined : json['fiatAmount'],
        'fiatAmountFormatted': !(0, runtime_1.exists)(json, 'fiatAmountFormatted') ? undefined : json['fiatAmountFormatted'],
        'fuelAmount': !(0, runtime_1.exists)(json, 'fuelAmount') ? undefined : json['fuelAmount'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'subject': !(0, runtime_1.exists)(json, 'subject') ? undefined : json['subject'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
    };
}
exports.FuelTransactionHistoryItemFromJSONTyped = FuelTransactionHistoryItemFromJSONTyped;
function FuelTransactionHistoryItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'fiatAmount': value.fiatAmount,
        'fiatAmountFormatted': value.fiatAmountFormatted,
        'fuelAmount': value.fuelAmount,
        'type': value.type,
        'subject': value.subject,
        'description': value.description,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}
exports.FuelTransactionHistoryItemToJSON = FuelTransactionHistoryItemToJSON;
/**
* @export
* @enum {string}
*/
var FuelTransactionHistoryItemTypeEnum;
(function (FuelTransactionHistoryItemTypeEnum) {
    FuelTransactionHistoryItemTypeEnum["DEBIT"] = "DEBIT";
    FuelTransactionHistoryItemTypeEnum["CREDIT"] = "CREDIT";
})(FuelTransactionHistoryItemTypeEnum = exports.FuelTransactionHistoryItemTypeEnum || (exports.FuelTransactionHistoryItemTypeEnum = {}));
